import { Alert, Snackbar } from '@mui/material'
import { CSSProperties, MouseEvent, useState } from 'react'

export const StreakBubble = ({ streakLength }: { streakLength: number }) => {
  const [isAlerting, setIsAlerting] = useState(false)

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    setIsAlerting(true)
  }

  const mainStyle: CSSProperties = {
    position: 'absolute',
    top: '-14px',
    right: '-14px',
    border: '1px solid black',
    width: '30px',
    borderRadius: '18px',
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'lawngreen',
    filter: `saturate(${streakLength / 12})`,
    color: 'black',
  }

  if (streakLength < 2) {
    return null
  } else {
    return (
      <div>
        <div style={mainStyle} onClick={handleClick}>
          {streakLength}
        </div>
        <Snackbar
          open={isAlerting}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          autoHideDuration={4000}
          onClose={() => setIsAlerting(false)}
        >
          <Alert onClose={() => setIsAlerting(false)} severity="success">
            🔥 You're on fire! {streakLength} in a row!
          </Alert>
        </Snackbar>
      </div>
    )
  }
}
